import { databaseVersion } from './appDBConfig';

export const getAppConfig = appConfigKey =>
  Object.assign({}, appConfig[appConfigKey || 'default'] || appConfig.default, {
    databaseVersion,
  });

const appConfig = {
  default: {
    subscriptionPage: 'http://app.spectrebowling.com/registration',
    apiServer: 'http://app.spectrebowling.com/api/',
    importServer: 'http://app.spectrebowling.com/api/',
    fileServer: 'http://app.spectrebowling.com/files/',
    appUrl: 'http://app.spectrebowling.com/',
    resettingPage: 'http://app.spectrebowling.com/resetting/request',
    commSocket: 'wss://app.spectrebowling.com/comm',
  },
  'app.spectrebowling.com': {
    subscriptionPage: 'http://app.spectrebowling.com/registration',
    apiServer: 'http://app.spectrebowling.com/api/',
    importServer: 'http://app.spectrebowling.com/api/',
    fileServer: 'http://app.spectrebowling.com/files/',
    appUrl: 'http://app.spectrebowling.com/',
    resettingPage: 'http://app.spectrebowling.com/resetting/request',
    commSocket: 'wss://app.spectrebowling.com/comm',
  },
  'local.spectrebowling.com': {
    subscriptionPage: 'http://local.spectrebowling.com/registration',
    apiServer: 'http://local.spectrebowling.com/api/',
    importServer: 'http://local.spectrebowling.com/api/',
    fileServer: 'http://local.spectrebowling.com/files/',
    appUrl: 'http://local.spectrebowling.com/',
    resettingPage: 'http://local.spectrebowling.com/resetting/request',
    commSocket: 'wss://local.spectrebowling.com/comm',
  },
};
